import type { ProductSetWithImageResponse } from '~/types/api'

export function transformSets(sets: ProductSetWithImageResponse[]) {
  return sets.map((set) => ({
    nid: set.nid,
    title: set.title,
    productLine: {
      title: set.productLine?.title,
      urlSlug: set.productLine?.urlSlug,
    },
    urlSlug: set.urlSlug,
    image: {
      url: set.products[0]?.images[0]?.url || set?.images[0]?.url,
      imageRatio:
        set.products[0]?.images[0]?.imageRatio || set?.images[0]?.imageRatio,
    },
    readyForConfigurator: set.readyForConfigurator,
    minimalProductPrice: set.minimalProductPrice,
    currency: set.currency,
  }))
}
